export default "__VITE_ASSET__DPy$LhDF__ 300w, __VITE_ASSET__DJPEeeoF__ 500w, __VITE_ASSET__NDmtzY$U__ 800w";